module.exports = __webpack_public_path__ + "static/media/20_000003.a3520965.jpg";